module.exports = __webpack_public_path__ + "static/media/righticon.dddd9a07.svg";